import { Avatar,Button,Typography,Tooltip } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import extractInitials,{extractName} from "../../Utils/userUtils.js";
import GroupList from "./GroupList";

const UserAccount = ({ fullWidth = false }) => {
  const userLogged = useSelector((store) => store.authentication.authenticatedUser);
  const {displayName: name} = userLogged;
  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      {name && (
        <>
          <Tooltip title={`${name}\nSee your groups`}>
            <Button
              fullWidth={fullWidth}
              startIcon={

                <Avatar
                  style={{ width: 24, height: 24, marginLeft:20,  color: "rgb(2, 31, 71)", fontSize: "0.750rem" }}
                  variant="circle"
                >
                  {extractInitials(name)}
                </Avatar>
              }
              style={{
                  marginBottom:5,
                backgroundColor: "rgba(255, 255, 255, 0.45)",
                color: "rgb(2, 31, 71)",
              }}
              variant="contained"
              onClick={handleClick}
            >
              
              <Typography key="Typography-Button" variant="body2">
                {extractName(name)}
              </Typography>
            </Button>
          </Tooltip>
{/*         {open && <GroupList anchorEl={anchorEl} handleClose={handleClose} open={open} />} 
 */}        </>
      )}
    </>
  );
};

UserAccount.propTypes = {
  fullWidth: PropTypes.bool,
};

export default UserAccount;
